export const METADATA_NAME_MAX_BYTES = 32;
export const METADATA_SYMBOL_MAX_BYTES = 10;
export const DISPLAY_TEXT_PATTERN: RegExp = /^[^\p{Cc}\p{Cs}]+$/u;
export const SYMBOL_TEXT_PATTERN: RegExp = /^[^\p{White_Space}\p{Cc}\p{Cs}]+$/u;
// Digits/#/* and non-emoji ZWJ text stay valid; keycaps and selectors are blocked.
export const METADATA_NAME_PATTERN: RegExp =
  /^(?![\s\S]*(?![0-9#*\u200D])[\p{Emoji}\p{Emoji_Component}\p{Extended_Pictographic}])[^\p{Cc}\p{Cs}]+$/u;
export const METADATA_SYMBOL_PATTERN: RegExp =
  /^(?![\s\S]*\p{Lowercase})(?![\s\S]*(?![0-9])[\p{Emoji}\p{Emoji_Component}\p{Extended_Pictographic}])[\p{L}\p{M}\p{N}]+$/u;

export function utf8ByteLength(value: string): number {
  let bytes = 0;
  for (const character of value) {
    const point = character.codePointAt(0) ?? 0;
    bytes += point <= 0x7f ? 1 : point <= 0x7ff ? 2 : point <= 0xffff ? 3 : 4;
  }
  return bytes;
}

/** Generated text may be shortened; authoritative metadata must be validated instead. */
export function truncateUtf8Text(value: string, maxBytes: number): string {
  let result = '';
  let bytes = 0;
  const segments = new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value);
  for (const { segment } of segments) {
    const segmentBytes = utf8ByteLength(segment);
    if (bytes + segmentBytes > maxBytes) break;
    result += segment;
    bytes += segmentBytes;
  }
  return result;
}

/** Code-point limits are applied only at complete grapheme boundaries. */
export function truncateDisplayText(value: string, maxCodePoints: number): string {
  let result = '';
  let count = 0;
  const segments = new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value);
  for (const { segment } of segments) {
    const segmentCount = Array.from(segment).length;
    if (count + segmentCount > maxCodePoints) break;
    result += segment;
    count += segmentCount;
  }
  return result;
}

export function isMetadataName(value: string): boolean {
  return METADATA_NAME_PATTERN.test(value) && utf8ByteLength(value) <= METADATA_NAME_MAX_BYTES;
}

export function isMetadataSymbol(value: string): boolean {
  return (
    METADATA_SYMBOL_PATTERN.test(value) &&
    value === value.toUpperCase() &&
    utf8ByteLength(value) <= METADATA_SYMBOL_MAX_BYTES
  );
}

export function validateOutcomeMetadataText(fields: { name: string; symbol: string }): void {
  if (!isMetadataName(fields.name)) {
    throw new Error(
      'Metadata name must contain 1–32 UTF-8 bytes without control characters or emoji',
    );
  }
  if (!isMetadataSymbol(fields.symbol)) {
    throw new Error(
      'Metadata symbol must contain 1–10 UTF-8 bytes of uppercase letters, marks, or numbers without emoji',
    );
  }
}
